import { EventBus } from '@/event-bus';

const readCooldownUntil = (storageKey) => {
  try {
    return Number(localStorage.getItem(storageKey)) || 0;
  } catch (error) {
    return 0;
  }
};

const writeCooldownUntil = (storageKey, timestamp) => {
  try {
    if (timestamp) {
      localStorage.setItem(storageKey, String(timestamp));
    } else {
      localStorage.removeItem(storageKey);
    }
  } catch (error) {
    return;
  }
};

const getErrorMessage = async (error, fallback) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text()).message || fallback;
    } catch (parseError) {
      return fallback;
    }
  }
  return data?.message || fallback;
};

export default (storageKey, cooldownSeconds = 60) => ({
  data() {
    return {
      isExporting: false,
      exportCountdown: 0,
      exportTimer: null,
    };
  },
  computed: {
    isExportDisabled() {
      return this.isExporting || this.exportCountdown > 0;
    },
    formattedExportCountdown() {
      const minutes = String(Math.floor(this.exportCountdown / 60)).padStart(2, '0');
      const seconds = String(this.exportCountdown % 60).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
  },
  mounted() {
    this.resumeExportCountdown();
  },
  beforeDestroy() {
    clearInterval(this.exportTimer);
  },
  methods: {
    async runExport(download) {
      if (this.isExportDisabled) return;
      this.isExporting = true;

      try {
        await download();
        this.startExportCountdown();
        EventBus.$emit('show-toast', {
          message:'Export is in progress. We’ll let you know by email once your file is ready to download.',
          type: 'success'
        });
      } catch (error) {
        EventBus.$emit('show-toast', {
          message: await getErrorMessage(error, 'Failed to export CSV'),
          type: 'error',
        });
      } finally {
        this.isExporting = false;
      }
    },

    startExportCountdown() {
      writeCooldownUntil(storageKey, Date.now() + cooldownSeconds * 1000);
      this.resumeExportCountdown();
    },

    resumeExportCountdown() {
      clearInterval(this.exportTimer);

      const tick = () => {
        const remaining = Math.ceil((readCooldownUntil(storageKey) - Date.now()) / 1000);
        if (remaining > 0) {
          this.exportCountdown = remaining;
          return;
        }
        this.exportCountdown = 0;
        writeCooldownUntil(storageKey, null);
        clearInterval(this.exportTimer);
      };

      tick();
      if (this.exportCountdown > 0) {
        this.exportTimer = setInterval(tick, 1000);
      }
    },
  },
});
